module.exports = __webpack_public_path__ + "static/logo_light-cd0b5915b0d1153a0f5b4394815572be.svg";